import { useActiveContentModuleModal } from './useActiveContentModuleModal.js'

/**
 * Determines whether content is being viewed in a modal overlay or on a content module page.
 * Derives this from URL state - modal views use query params, page views don't.
 */
export const useContentViewMode = () => {
  const { contentId, contentType } = useActiveContentModuleModal()

  return {
    /**
     * True when viewing content in a modal overlay (URL has content module params)
     */
    isModalView: !!contentId && !!contentType,
    /**
     * True when viewing content on its dedicated page (no modal params in URL)
     */
    isPageView: !contentId || !contentType,
  }
}
